import React, { useState, useEffect } from "react";
import { hitGetProfileApi } from "../../../Redux/Professional/GetProfileSlice";
import { showToast } from "../../../Helper/Toast";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import four1 from "../../../assets/img/four 1.svg";
import four2 from "../../../assets/img/four 2.svg";
import four3 from "../../../assets/img/four 3.svg";
import four4 from "../../../assets/img/four 4.svg";
import four5 from "../../../assets/img/four 5.svg";
import four6 from "../../../assets/img/four 6.svg";
import four7 from "../../../assets/img/four 7.svg";
import four8 from "../../../assets/img/four 8.svg";
import four9 from "../../../assets/img/pricing 9.svg";
import EarlySupporterDiscount from "../../../assets/img/Early Supporter Discount.svg";
import {
  ApiBaseUrl,
  createStripeSessionSubscriptionProfessional,
  stripeKey,
  monthlyPlanPriceId,
} from "../../../Utils/Constants";
import { getMobileRedirectionAuthToken } from "../../../Helper/mobileAuth";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";

const BuyProPlanFromMobile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [subscriptionActivated, setSubscriptionActivated] = useState(false);
  const [professionalData, setProfessionalData] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchProfile = async () => {
      const parsedToken = getMobileRedirectionAuthToken();
      if (!parsedToken) {
        navigate("/login", { replace: true });
        return;
      }

      setToken(parsedToken);

      try {
        const response = await dispatch(hitGetProfileApi(parsedToken));
        if (!isMounted) {
          return;
        }

        if (response?.payload?.status === true && response.payload.data) {
          setProfessionalData(response.payload.data);
          if (response.payload.data.isSubscribed === 1) {
            setSubscriptionActivated(true);
          }
        }
      } catch {
        // 401: global axios interceptor clears storage, alert, redirect to /login
      }
    };

    fetchProfile();

    return () => {
      isMounted = false;
    };
  }, [dispatch, navigate]);

  const stripePromise = loadStripe(stripeKey);

  const handleSubscriptionWhenNoPlan = async () => {
    const authToken = token || getMobileRedirectionAuthToken();
    if (!authToken) {
      navigate("/login", { replace: true });
      return;
    }

    await stripePromise;

    try {
      const response = await axios.post(
        `${ApiBaseUrl}${createStripeSessionSubscriptionProfessional}`,
        {
          priceId: monthlyPlanPriceId,
          isFromOfferPage: 1,
          isFromOnboarding: 0,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: authToken,
          },
        }
      );

      if (response.data?.status === true && response.data?.data?.url) {
        window.location.href = response.data.data.url;
      } else {
        showToast(
          response.data?.message ||
            response.data?.data?.message ||
            "Unable to start subscription checkout. Please try again.",
          "error"
        );
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // Global axios interceptor: clear storage, toast, redirect to /login
        return;
      }
      const message =
        error?.response?.data?.message ||
        "Something went wrong. Please try again.";
      showToast(message, "error");
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="custom_container padding_top manage-dashboard-screen">
      <div className="business-form-4 mt-0">
        <div className="business-form__title_4 mt-0 mb-4">
          <div className="service_area_search">
            <p>
              <span>
                {" "}
                <img
                  src={EarlySupporterDiscount}
                  alt="EarlySupporterDiscount"
                  className="mb-1 me-2"
                />
                Early Supporter Discount
              </span>
            </p>
          </div>
        </div>

        <form>
          <div className="service-area">
            <div className="service-area__price">
              <h2>$ 149 /month</h2>
              <h1>$99 </h1>
              <span>/month</span>
            </div>
            <div className="business-form__title_4 mt-0">
              <div className="service_area_search">
                <p>
                  <span>33.56% OFF Founder Pricing</span>
                </p>
              </div>
            </div>

            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four1} alt="Credit" />
                </span>
              </div>
              <div>
                <p>
                  100 Credits Per Month
                  <br />
                  <span>Use for bids, boosts, and much more.</span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four2} alt="Boosted_Visibility" />
                </span>
              </div>
              <div>
                <p>
                  Top-Listed Pro Visibility <br />
                  <span>
                    Appear as a recommended professional in client searches.
                  </span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four3} alt="Exclusive_Promotions" />
                </span>
              </div>
              <div>
                <p>
                  Exclusive Promotions <br />
                  <span>Direct, non-competitive bids sent to you.</span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four4} alt="Import_Reviews" />
                </span>
              </div>
              <div>
                <p>
                  Import Reviews
                  <br />
                  <span>Import your Google business reviews.</span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four5} alt="Full_Client_Insights" />
                </span>
              </div>
              <div>
                <p>
                  Full Client Insights <br />
                  <span>View past jobs, budget ranges, and total spends.</span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four6} alt="Bid_credit_protection" />
                </span>
              </div>
              <div>
                <p>
                  Bid Credit Protection <br />
                  <span>Credits refunded if the job posting is removed.</span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four9} alt="See_the_number_of_bids_on_each_job" />
                </span>
              </div>
              <div>
                <p>
                  See the number of bids on each job <br />
                  <span>Track how many professionals have bid on each job.</span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four7} alt="Bid_credit_protection" />
                </span>
              </div>
              <div>
                <p>
                  Ready-to-Go (RTG) Job Access <br />
                  <span>
                    Bid on high-intent clients ready to hire immediately.
                  </span>
                </p>
              </div>
            </div>
            <div className="expand-area">
              <div className="expand-button">
                <span>
                  <img src={four8} alt="Bid_credit_protection" />
                </span>
              </div>
              <div>
                <p>
                  Good–Better–Best (GBB) Bid Options
                  <br />
                  <span>
                    Offer tiered estimates for clearer, higher-converting
                    proposals.
                  </span>
                </p>
              </div>
            </div>

            <div className="form-actions-upgrate">
              {!subscriptionActivated ? (
                <button
                  type="button"
                  className="next-btn"
                  onClick={() => {
                    handleViewDetails();
                    handleSubscriptionWhenNoPlan();
                  }}
                >
                  Upgrade to Pro Now - $99/month{" "}
                </button>
              ) : (
                <button
                  className="next-btn"
                  disabled={subscriptionActivated}
                >
                  Already Subscribed
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BuyProPlanFromMobile;
